var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"placeholder":_vm.placeholder,"source":_vm.selectData,"value":_vm.filterItem.selectedItem},on:{"search":_vm.selectDataSearch,"input":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }